/**
 * bunny.net Stream Analytics API
 * Metrics come from data sources with different prerequisites: some need only standard CDN request logging, others need CMCD v1 query-string enrichment or a CMCD v2 player beacon - see each endpoint\'s description for which. If its required source isn\'t enabled, an endpoint returns empty/zero results, not an error.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { BotBreakdownResponse } from '../model/bot-breakdown-response';
// @ts-ignore
import { BrowserBreakdownResponse } from '../model/browser-breakdown-response';
// @ts-ignore
import { ContentTypeFilter } from '../model/content-type-filter';
// @ts-ignore
import { DeviceBreakdownResponse } from '../model/device-breakdown-response';
// @ts-ignore
import { GeographyResponse } from '../model/geography-response';
// @ts-ignore
import { OsBreakdownResponse } from '../model/os-breakdown-response';
// @ts-ignore
import { StreamAnalyticsCmcdPostPullZoneIdParameter } from '../model/stream-analytics-cmcd-post-pull-zone-id-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-geography-get-limit-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetWindowSecondsParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-viewers-current-get-window-seconds-parameter';
// @ts-ignore
import { StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetBucketSecondsParameter } from '../model/stream-analytics-v1-pull-zone-id-audience-viewers-peak-get-bucket-seconds-parameter';
// @ts-ignore
import { TimeSeriesGranularity } from '../model/time-series-granularity';
// @ts-ignore
import { UserAgentsResponse } from '../model/user-agents-response';
// @ts-ignore
import { ViewersResponse } from '../model/viewers-response';
// @ts-ignore
import { ViewsResponse } from '../model/views-response';
// @ts-ignore
import { ViewsTimeSeriesMetric } from '../model/views-time-series-metric';
// @ts-ignore
import { ViewsTimeSeriesResponse } from '../model/views-time-series-response';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface StreamAnalyticsV1PullZoneIdAudienceBotGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceBrowserGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceDeviceGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceGeographyGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of countries to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceOsGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceUserAgentsGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Restrict to one or more country codes (repeatable) - matches any of the given values. */
  countryCode?: string[];
  /** Restrict to one or more browsers (repeatable) - matches any of the given values. */
  browser?: string[];
  /** Restrict to one or more operating systems (repeatable) - matches any of the given values. */
  os?: string[];
  /** Restrict to one or more device categories (repeatable) - matches any of the given values. */
  deviceCategory?: string[];
  /** Restrict to one or more bot categories (repeatable) - matches any of the given values. Use \&#39;Human\&#39; for non-bot traffic; every value returned by /audience/bot is accepted here. */
  botCategory?: string[];
  /** De-duplicate by viewer instead of counting every playback-start event. */
  unique?: boolean;
  /** Maximum number of rows to return. */
  limit?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetLimitParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Seconds back to look for activity (default 60). */
  windowSeconds?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetWindowSecondsParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Bucket width for detecting simultaneous overlap (default 60s, minimum 60s). */
  bucketSeconds?: StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetBucketSecondsParameter;
}

export interface StreamAnalyticsV1PullZoneIdAudienceViewsGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** De-duplicate by a best-effort viewer identity instead of counting every playback-start event. */
  unique?: boolean;
}

export interface StreamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGetRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  from: string;
  to: string;
  /** Restrict to specific live stream IDs (repeatable). Combine with videoId to correlate a live stream with its VOD recording - matches either. */
  liveId?: string[];
  /** Restrict to specific video IDs (repeatable). Combine with liveId to correlate a live stream with its VOD recording - matches either. */
  videoId?: string[];
  /** Restrict to live or VOD assets. Only applies when neither liveId nor videoId is given. */
  contentType?: ContentTypeFilter;
  /** Bucket width for the time series. More values may be added over time - treat this set as open, not exhaustive. */
  granularity?: TimeSeriesGranularity;
  /** Starts (default) counts every play per bucket. Unique de-duplicates by viewer per bucket. */
  metric?: ViewsTimeSeriesMetric;
}

@Injectable({
  providedIn: 'root',
})
export class AudienceService {
  protected basePath = 'https://mc-cwlfiqxct9.bunny.run';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Views by bot category
   * Groups view counts by bot category (e.g. search engine bot, crawler) between \&#39;from\&#39; and \&#39;to\&#39;, with a single \&#39;Human\&#39; row for non-bot traffic. Every category returned here can be passed back as \&#39;?botCategory&#x3D;\&#39; on any audience endpoint, \&#39;Human\&#39; included. unique&#x3D;true de-duplicates by viewer; limit caps the number of rows returned. Can be narrowed to a single country/browser/OS/device category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceBotGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBotGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<BotBreakdownResponse>;
  public streamAnalyticsV1PullZoneIdAudienceBotGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBotGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<BotBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceBotGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBotGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<BotBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceBotGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBotGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBotGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBotGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBotGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/bot`;
    return this.httpClient.request<BotBreakdownResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views by browser
   * Groups view counts by browser between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer; limit caps the number of rows returned. Can be narrowed to a single country/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceBrowserGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBrowserGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<BrowserBreakdownResponse>;
  public streamAnalyticsV1PullZoneIdAudienceBrowserGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBrowserGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<BrowserBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceBrowserGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBrowserGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<BrowserBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceBrowserGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceBrowserGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBrowserGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBrowserGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceBrowserGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/browser`;
    return this.httpClient.request<BrowserBreakdownResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views by device category
   * Groups view counts by device category (e.g. desktop, smartphone, tablet) between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer; limit caps the number of rows returned. Can be narrowed to a single country/browser/OS/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceDeviceGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceDeviceGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<DeviceBreakdownResponse>;
  public streamAnalyticsV1PullZoneIdAudienceDeviceGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceDeviceGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<DeviceBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceDeviceGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceDeviceGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<DeviceBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceDeviceGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceDeviceGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceDeviceGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceDeviceGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceDeviceGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/device`;
    return this.httpClient.request<DeviceBreakdownResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views by country
   * Groups view counts by country between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer; limit caps the number of countries returned. Can be narrowed to a single browser/OS/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<GeographyResponse>;
  public streamAnalyticsV1PullZoneIdAudienceGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<GeographyResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<GeographyResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceGeographyGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceGeographyGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceGeographyGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceGeographyGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceGeographyGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/geography`;
    return this.httpClient.request<GeographyResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views by operating system
   * Groups view counts by operating system between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer; limit caps the number of rows returned. Can be narrowed to a single country/browser/device category/bot category with the corresponding filter parameter.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceOsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceOsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<OsBreakdownResponse>;
  public streamAnalyticsV1PullZoneIdAudienceOsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceOsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<OsBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceOsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceOsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<OsBreakdownResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceOsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceOsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceOsGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceOsGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceOsGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/os`;
    return this.httpClient.request<OsBreakdownResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views by user agent summary
   * Groups view counts by a summary of browser, operating system, device category, and bot classification between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer; limit caps the number of rows returned. See also /audience/browser, /audience/os, /audience/device, and /audience/bot for single-dimension breakdowns.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceUserAgentsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceUserAgentsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<UserAgentsResponse>;
  public streamAnalyticsV1PullZoneIdAudienceUserAgentsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceUserAgentsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<UserAgentsResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceUserAgentsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceUserAgentsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<UserAgentsResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceUserAgentsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceUserAgentsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceUserAgentsGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceUserAgentsGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceUserAgentsGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const countryCode = requestParameters?.countryCode;
    const browser = requestParameters?.browser;
    const os = requestParameters?.os;
    const deviceCategory = requestParameters?.deviceCategory;
    const botCategory = requestParameters?.botCategory;
    const unique = requestParameters?.unique;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (countryCode) {
      countryCode.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'countryCode');
      });
    }
    if (browser) {
      browser.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'browser');
      });
    }
    if (os) {
      os.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'os');
      });
    }
    if (deviceCategory) {
      deviceCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'deviceCategory');
      });
    }
    if (botCategory) {
      botCategory.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'botCategory');
      });
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, 'limit');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/user-agents`;
    return this.httpClient.request<UserAgentsResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Concurrent viewers right now
   * Distinct viewers with any streaming activity in the trailing windowSeconds - a live gauge, not a range total. See GET /audience/viewers/peak for a historical busiest moment.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceViewersCurrentGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ViewersResponse>;
  public streamAnalyticsV1PullZoneIdAudienceViewersCurrentGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ViewersResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewersCurrentGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ViewersResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewersCurrentGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersCurrentGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewersCurrentGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const windowSeconds = requestParameters?.windowSeconds;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (windowSeconds !== undefined && windowSeconds !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>windowSeconds, 'windowSeconds');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/viewers/current`;
    return this.httpClient.request<ViewersResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Highest concurrent viewer count in a range
   * Buckets viewers by bucketSeconds within \&#39;from\&#39; and \&#39;to\&#39; and returns the count from the busiest bucket. Measures overlap in time, not a summed count - see GET /audience/views for that. Concurrency is resolved at bucketSeconds granularity, not to the instant: two viewers active in the same bucket count as 2 even if their requests didn\&#39;t overlap, and a viewer who requested nothing during a bucket isn\&#39;t counted in it.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceViewersPeakGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ViewersResponse>;
  public streamAnalyticsV1PullZoneIdAudienceViewersPeakGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ViewersResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewersPeakGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ViewersResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewersPeakGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewersPeakGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewersPeakGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewersPeakGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewersPeakGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const bucketSeconds = requestParameters?.bucketSeconds;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (bucketSeconds !== undefined && bucketSeconds !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>bucketSeconds, 'bucketSeconds');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/viewers/peak`;
    return this.httpClient.request<ViewersResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views (playback starts) in a time range
   * Counts playback-start events between \&#39;from\&#39; and \&#39;to\&#39;. unique&#x3D;true de-duplicates by viewer instead of counting every play. This is a range total, not a concurrency measure - see GET /audience/viewers/current or /peak for \&#39;how many were watching at once\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceViewsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ViewsResponse>;
  public streamAnalyticsV1PullZoneIdAudienceViewsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ViewsResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ViewsResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewsGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const unique = requestParameters?.unique;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (unique !== undefined && unique !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>unique, 'unique');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/views`;
    return this.httpClient.request<ViewsResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Views (playback starts) bucketed over time
   * Buckets playback-start events into \&#39;granularity\&#39;-sized time slices between \&#39;from\&#39; and \&#39;to\&#39;. metric&#x3D;Starts (default) counts every play per bucket; metric&#x3D;Unique de-duplicates by viewer per bucket. Each bucket is independent, not a running concurrency series - see GET /audience/viewers/current for \&#39;how many at a given moment\&#39;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<ViewsTimeSeriesResponse>;
  public streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<ViewsTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<ViewsTimeSeriesResponse>>;
  public streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet(
    requestParameters?: StreamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet.');
    }
    const from = requestParameters?.from;
    if (from === null || from === undefined) {
      throw new Error('Required parameter from was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet.');
    }
    const to = requestParameters?.to;
    if (to === null || to === undefined) {
      throw new Error('Required parameter to was null or undefined when calling streamAnalyticsV1PullZoneIdAudienceViewsTimeseriesGet.');
    }
    const liveId = requestParameters?.liveId;
    const videoId = requestParameters?.videoId;
    const contentType = requestParameters?.contentType;
    const granularity = requestParameters?.granularity;
    const metric = requestParameters?.metric;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>from, 'from');
    }
    if (to !== undefined && to !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>to, 'to');
    }
    if (liveId) {
      liveId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'liveId');
      });
    }
    if (videoId) {
      videoId.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'videoId');
      });
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }
    if (granularity !== undefined && granularity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>granularity, 'granularity');
    }
    if (metric !== undefined && metric !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metric, 'metric');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (BunnyJwt) required
    localVarCredential = this.configuration.lookupCredential('BunnyJwt');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
    }

    // authentication (BunnyAccessKey) required
    localVarCredential = this.configuration.lookupCredential('BunnyAccessKey');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('AccessKey', localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/v1/${this.configuration.encodeParam({ name: 'pullZoneId', value: pullZoneId, in: 'path', style: 'simple', explode: false, dataType: 'StreamAnalyticsCmcdPostPullZoneIdParameter', dataFormat: 'uint64' })}/audience/views/timeseries`;
    return this.httpClient.request<ViewsTimeSeriesResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
